import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { NotificationServices } from "../services/NotificationServices";
import { RpaServices } from "../services/RpaServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
export const fetchNotificationCount = createAsyncThunk(
  "notification/fetchNotificationCount",
  async () => {
    const response = await NotificationServices.getUserNotificationCounts();
    return response?.data?.totalUnreadNotifications;
  }
);
export const fetchCommentCount = createAsyncThunk(
  "notification/fetchCommentCount",
  async () => {
    const response = await NotificationServices.getUserNotificationCounts();
    return response?.data?.Comments?.unread;
  }
);
export const fetchNewCaseNotificationCount = createAsyncThunk(
  "notification/fetchNewCaseNotificationCount",
  async () => {
    const response = await RpaServices.getHoldApplication();
    return response.data.rpaRequests;
  }
);
const NotificationSlice = createSlice({
  name: "notification",
  initialState: {
    notificationCount: 0,
    status: "idle",
    error: null,
    newCommentCount: 0,
    newCaseNotificationCount: 0,
    rpaPendingRequests: 0,
    newCaseStatus: "idle",
    newCaseError: null,
    newOtpMessage: "",
    messageId: "",
  },
  reducers: {
    updateNewOtpMessage: (state, action) => {
      state.newOtpMessage = action.payload;
    },
    updateMessageId: (state, action) => {
      state.messageId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchNotificationCount.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchNotificationCount.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.notificationCount = action.payload; // Update notification count with API data
      })
      .addCase(fetchNotificationCount.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        handleApiErrorResponses(action.error);
      })
      .addCase(fetchCommentCount.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCommentCount.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.newCommentCount = action.payload;
      })
      .addCase(fetchCommentCount.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        handleApiErrorResponses(action.error);
      })
      .addCase(fetchNewCaseNotificationCount.pending, (state) => {
        state.newCaseStatus = "loading";
      })
      .addCase(fetchNewCaseNotificationCount.fulfilled, (state, action) => {
        state.newCaseStatus = "succeeded";
        state.newCaseNotificationCount = action.payload.newCase.NEW;
        state.rpaPendingRequests =
          Number(action?.payload?.HOLD || 0) +
          Number(action?.payload?.NEW || 0) +
          Number(action?.payload?.STARTMANUALLY || 0);
      })
      .addCase(fetchNewCaseNotificationCount.rejected, (state, action) => {
        state.newCaseStatus = "failed";
        state.newCaseError = action.error.message;
        handleApiErrorResponses(action.error);
      });
  },
});
export const { updateNewOtpMessage, updateMessageId } =
  NotificationSlice.actions;
export default NotificationSlice.reducer;
